module.exports = __webpack_public_path__ + "static/img/icon_arch.71fa5e11.svg";